

import React, { useState } from 'react';
import { IconArrowNarrowRight, IconChevronRight } from "@tabler/icons-react";
import Projects from '../Projects';

const Solutions = () => {

  return (
    <div>
           <section className="mt-[71px] bg-[url(../images/banner-bg.png)] bg-cover bg-no-repeat md:mt-[87px] xl:mt-0" style={{marginBottom:"100px"}}>
     <div className="bg-primary bg-opacity-40 py-[52px]">
         <div className="container text-n8">
           <h3 className="h3 mb-2.5">Solutions</h3>
           <ul className="flex flex-wrap items-center gap-2">
             <li><a href="/" className="home-link">Home</a></li>
             <li className="flex items-center">
                <IconChevronRight size={24} />
             </li>
             <li><a href="/solutions" className="home-link">Solutions</a></li>
           </ul>
         </div>
       </div>
     </section>

      <Projects/>
    </div>
  );
};

export default Solutions;